import React, { useCallback, useState } from 'react';
import {
    useSignState
} from 'context/signview';
import { useMutation, useQueryClient } from 'react-query';
import { fetcher } from 'api/client';
import { clientContractAction } from 'api/actions/contracts';
import { useTranslation } from 'react-i18next';
import useFileUpload from 'api/hooks/file/useFileUpload';
import { Button, ListGroup, ListGroupItem, TabPane, Modal, ModalHeader, ModalBody } from 'reactstrap';

export function AttachmentItem({ attachment, readonly = false, previewVideo = false }) {

    const { name, required, url, filename } = attachment;

    const { t } = useTranslation();
    const [isPreviewOpen, setIsPreviewOpen] = useState(false)

    const queryClient = useQueryClient();

    const handleDownloadAttachment = useCallback(() => {
        window.open(url, 'blank');
    }, [url]);

    const { contractId, jwt } = useSignState();

    const { mutate: mutateUploadAttachment } = useMutation((payload) =>
        fetcher(clientContractAction(contractId, 'uploadattachment', payload), jwt), {
        onSuccess: () => {
            queryClient.invalidateQueries('client-contract');
        }
    })

    const { chooseFileAndUploadFile } = useFileUpload({
        jwt,
        onSuccess: async ({ url, BaseFileName }) => {
            mutateUploadAttachment({
                url, filename: BaseFileName, attachmentId: attachment._id
            })
        },
    })
    // const { mutate: updateMutation } = useMutation(() => fetcher(upload))
    const handlePreviewVideo = () => setIsPreviewOpen(true);

    const handleUpload = () => {
        chooseFileAndUploadFile({ convertToPdf: true }, {
            accept: '.pdf,image/*,.docx,.doc'
        })
    }
    return (
        <ListGroupItem className="d-flex">
            <div className="d-flex border-right">
                <div className="lead align-self-center mb-0 mr-3">
                    <i className="fas fa-1x fa-paperclip"></i>
                </div>
            </div>
            <div className="bg-grey p-3 w-100">
                <p className="d-block font-weight-bold mb-0">
                    {url ?
                        <i className="fas fa-check-circle text-success"></i>
                        :
                        <i className="fas fa-question-circle text-warning"></i>
                    }
                    {' '}{name}{required ? '*' : ''}</p>
                <small className="d-block text-muted mb-2">
                    {filename}
                </small>
                {url &&
                    <Button
                        size="sm"
                        className="mr-1"
                        onClick={previewVideo ? handlePreviewVideo : handleDownloadAttachment }>{t('sign.contract.view_attachment')}
                    </Button>
                }
                {!readonly &&
                    <Button
                        size="sm"
                        color="primary"
                        onClick={handleUpload}>{t('sign.contract.upload_attachment')}
                    </Button>
                }
                { previewVideo && <ZoomVideoPreview isOpen={isPreviewOpen} toggle={() => setIsPreviewOpen(!isPreviewOpen)} video={url} /> }
            </div>
        </ListGroupItem>
    )
}


export default function AttachmentsTab() {

    const { contract } = useSignState();

    const participants = contract.participants || [];

    const { t } = useTranslation();

    return (
        <TabPane id="attachments" active>
            <p className="mb-3">
                {t('sign.contract.attachment_description')}
            </p>
            <hr />
            {participants.map((p) => (
                <div className="mt-4" key={p._id}>
                    <h5 className="font-weight-bold mt-3">{p.name} {p.last_name || ''}</h5>
                    <ListGroup>
                        {p.attachments.map((attachment) =>
                            <AttachmentItem
                                key={attachment._id}
                                attachment={attachment}
                                readonly={
                                    contract?.signViewOptions.currentParticipant._id !== p._id ||
                                    contract.status !== 'RECEIVED_TO_FILL'
                                }
                            />
                        )}
                        {
                            contract.requireVideoDeclaration && p.isHost && (contract.zoom?.recordings?.trato_file?.url || contract.zoom?.localRecordingUrl) &&
                            <AttachmentItem
                                attachment={{name: "Zoom Video", required: false, url: contract.zoom?.recordings?.trato_file?.url || contract.zoom?.localRecordingUrl, filename: 'zoom.mp4' }}
                                readonly
                                previewVideo
                            />
                            
                        }
                    </ListGroup>
                </div>
            ))}
        </TabPane>
    );
}

function ZoomVideoPreview({ isOpen, toggle, video }) {
    return (
        <Modal isOpen={isOpen} centered size="md">
            <ModalHeader toggle={toggle}>Zoom Video</ModalHeader>
            <ModalBody>
                <video controls className="w-100">
                    <source src={video} type="video/mp4" />
                </video>
            </ModalBody>
        </Modal>
    )
}
